import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'What ages is this for?',
    a: 'Perfect for kids aged 2 to 12.'
  }, {
    q: 'Are the ingredients expensive?',
    a: 'Not at all. We use staples you already have in your pantry.'
  }, {
    q: "I'm not a good cook, can I do this?",
    a: 'If you can boil water and chop an apple, you can master these recipes.'
  }, {
    q: 'How do I receive the product?',
    a: 'You get instant digital access via email immediately after purchase.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <section className="bg-gray-50 py-16 px-4" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <h2 className="text-3xl font-extrabold text-[#1f2e10] text-center mb-10 uppercase" data-id="element-47">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-49">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-50">
                <span className="font-bold text-[#1f2e10] pr-4" data-id="element-51">{faq.q}</span>
                <motion.div animate={{
              rotate: openIdx === idx ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-52">
                  <ChevronDown className="text-green-600 flex-shrink-0" data-id="element-53" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-54">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-55">
                    <div className="px-6 pb-4 text-gray-600 border-t border-gray-100 pt-4" data-id="element-56">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}